import { GetFlightGroupResponse, PostFlightManualType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateFlightManual = () => {
	const queryClient = useQueryClient()

	return useMutation<GetFlightGroupResponse, Error, { tripId: string; data: PostFlightManualType }>({
		mutationFn: async ({ tripId, data }) => {
			const response = await api.post<GetFlightGroupResponse>(`/trips/${tripId}/flights/manual`, data)
			return response.data
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.flights(variables.tripId) })
		},
	})
}
